import React from 'react';
import { Box } from '@mui/material';
import HeroSection from './HeroSection';
import HeaderSection from './HeaderSection';
import TestimonialSlider from './TestimonialSlider';
import ProductSection from './ProductSection';
import ExternalProductSection from './ExternalProductSection';
import PlansSection from './PlansSection';
import StorySection from './StorySection';
import WhoSection from './WhoSection';

// Carousel styles
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';



const plans = [
  {
    title: 'Essential Care',
    price: '₹799',
    features: [
      'Personalised diet plan',
      'Lifestyle guidance',
      '1 doctor consultation',
      'WhatsApp support',
      '1 month care',
    ],
    highlight: false,
  },
  {
    title: 'Balanced Care',
    price: '₹1299',
    features: [
      'Everything in Essential',
      '2 doctor consultations',
      'Ayurvedic face mask',
      '2 months care',
    ],
    highlight: true,
  },
  {
    title: 'Advanced Care',
    price: '₹1999',
    features: [
      'Everything in Balanced',
      'Customised herbal medicines',
      '3 months care',
    ],
    highlight: false,
  },
];

// Common styles for testimonial boxes
const testimonialBoxStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  px: 1,
  boxSizing: 'border-box',
  padding: '30px 20px',
  '& img': {
    width: '110%',
    height: {xs: 'auto', sm: '340px', md: '340px', lg: 'auto'},
    objectFit: 'cover',
    borderRadius: 2,
    boxShadow: '10px 10px 10px rgba(0,0,0,0.15)',
    transition: 'transform 0.2s ease-in-out',
    background: '#fff',
    '&:hover': {
      transform: 'scale(1.04)'
    }
  }
};

  // Slider settings for react-slick
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: '60px', // adjust for edge spacing
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          centerPadding: '20px',

        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          centerPadding: '40px',
        }
      }
    ]
  };

export default function HomePage() {
  return (
    <Box sx={{ 
      position: 'relative',
      width: '100%',
      overflowX: 'hidden'
    }}>
      <HeaderSection />
      <HeroSection />
      <TestimonialSlider 
        testimonials={[
          require('../assets/testimonials/1.png'),
          require('../assets/testimonials/2.png'),
          require('../assets/testimonials/3.png'),
          require('../assets/testimonials/4.png'),
          require('../assets/testimonials/5.png'),
          require('../assets/testimonials/6.png'),
          require('../assets/testimonials/7.png'),
          require('../assets/testimonials/8.png'),
          require('../assets/testimonials/9.png'),
        ]}
        testimonialBoxStyles={testimonialBoxStyles}
        sliderSettings={sliderSettings}
      />
      <ProductSection />
      <ExternalProductSection />
      <PlansSection plans={plans} />
      <StorySection />
      <WhoSection />
    </Box>
  );
}
